import * as cookie from 'cookie'
import { Monitoring } from '@grammarly/telemetry'
import { getConfig } from '../../config'

const cookieDomain = getConfig().domains.cookie

export enum Cookie {
  CsrfToken = 'csrf-token',
  AutoTest = 'autotest',

  // Cookies for Discounts
  GrammarlyDiscountName = 'GrammarlyDiscountName',
  GrammarlyDiscountValue = 'GrammarlyDiscountValue',
  GrammarlyDiscountType = 'GrammarlyDiscountType',

  // Cookie to flag that desktop integration (llama) was downloaded from this browser
  LlamaDesktopIntegrationDownload = 'desktop_integration_download',

  // Cookies for extension installs
  grChromeStoreInstallUTM = 'grChromeStoreInstallUTM',
  grInstallSource = 'grInstallSource',
  isGrammarlyUser = 'isGrammarlyUser',
  disableBingUETTracking = '_uetmsdns',

  // Server-allowed cookies will be passed through by facade to CMS server render
  PlagiarismSignupCtaExpStickyTreatment = 'grs_plagSCtaExpSticky',

  // Static Fallback Redirect cookies
  StaticFallbackRedirect = 'staticFallbackRedirect',

  // Cookie set in CMS for Pardot related thanks page request
  pardotAssociatedEmail = 'pardotAssociatedEmail',
  pardotAssociatedUrl = 'pardotAssociatedUrl',
  utmParams = 'utmParams',

  // Gnar-related cookies
  gnarWebsiteSessionId = 'gnar_websiteSessionId',

  // Localization cookies
  CurrentLocale = 'currentLocale',
}

const logServerSideWarning = (cookieName: string, action: 'parse' | 'set') => {
  const stackTraceError = new Error()
  Monitoring.Logging.getLogger('cookie.interception').warn(
    `Cannot ${action} cookie ${action === 'set' ? 'to' : 'from'} document at the server-side`,
    {
      cookieName,
      stackTrace: stackTraceError.stack,
    }
  )
}

export const getCookie = (name: Cookie): string | undefined => {
  if (!IS_CLIENT_SIDE) {
    logServerSideWarning(name, 'parse')
    return
  }

  return cookie.parse(document.cookie)[name]
}

export const setCookie = (name: Cookie, value: boolean | string, maxAgeSec?: number): void => {
  if (!IS_CLIENT_SIDE) {
    logServerSideWarning(name, 'set')
    return
  }

  document.cookie = cookie.serialize(name, value.toString(), {
    expires: maxAgeSec ? new Date(Date.now() + maxAgeSec * 1000) : undefined,
    path: '/',
    domain: cookieDomain,
  })
}

export const deleteCookie = (name: string | Cookie) => {
  document.cookie = `${name}=;path=/;domain=${cookieDomain};expires=Thu, 01 Jan 1970 00:00:01 GMT`
}
